<div class="home-container">
  <div class="home-content">
    <h1 class="home-title">
Welcome!</h1>
    <p class="home-message">
FrogOne Admin Panel.
    </p>
  </div>
</div>